import Vue from 'vue'
//import Router from 'vue-router'
import Login from '@/pages/Login'
import Debug from '@/pages/Debug'
import Customer from './modules/customer'
import Scheduler from './modules/scheduler'

//Vue.use(Router)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: "/login",
    },
    {
      name: 'login',
      path: '/login',
      component: Login,
      meta: {
        title: '绑定手机号'
      }
    },
    {
      name: 'debug',
      path: '/debug',
      component: Debug,
      meta: {
        title: 'debug'
      }
    },
    ...Customer,
    ...Scheduler,
  ],
  linkActiveClass: 'selectTaga'
  // linkActiveClass: 'mui-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js